import { dictionary, Language } from "@/utils/dictionary";

/**
 * Traduce el error crudo del backend (error_message del draft/render) a un
 * mensaje corto y entendible para el usuario. Los detalles técnicos siguen
 * viviendo en la DB (error_logs) para diagnóstico — aquí solo decidimos qué
 * mostrar en la UI.
 */
export function friendlyVideoError(
  raw: string | null | undefined,
  lang: Language
): string | undefined {
  if (!raw) return undefined;

  // Bloqueo de política por rostros realistas en las imágenes de referencia
  // (desde 2026-07-06). Mensaje en términos de producto, sin exponer proveedores.
  if (/content_policy_violation|likenesses of real people/i.test(raw)) {
    return (
      dictionary["video-error-policy-face"]?.[lang] ||
      "Por ahora no podemos generar videos con personas. Tus créditos fueron devueltos automáticamente."
    );
  }

  // Cualquier otro error técnico (stacktraces, HTTP, URLs) → mensaje genérico.
  const looksTechnical =
    raw.length > 160 || /client error|traceback|unprocessable|https?:\/\//i.test(raw);
  if (looksTechnical) {
    return (
      dictionary["video-error-generic"]?.[lang] ||
      "No pudimos crear este video. Tus créditos fueron devueltos automáticamente."
    );
  }

  // Mensajes cortos ya legibles (p. ej. escritos por el propio backend) se muestran tal cual.
  return raw;
}
